import React from 'react'
import { l } from '@manychat/manyui'

import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { NoButtonStatContextProvider } from 'common/builder/components/chart/FlowChart/contexts/ButtonStatContext'
import TextWithIcon from 'common/builder/components/chart/FlowChart/nodes/shared/TextWithIcon/TextWithIcon'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'

interface EmptyDynamicProps {
  fallback: FlowChartButton | null
  icon: string
}

export const EmptyDynamic = ({ fallback, icon }: EmptyDynamicProps) => {
  return (
    <NoButtonStatContextProvider>
      <ContentContainer isEmpty>
        <TextWithIcon icon={icon} empty>
          {l.translate('Add a Request For Dynamic Content')}
        </TextWithIcon>
        {fallback !== null && <Button button={fallback} />}
      </ContentContainer>
    </NoButtonStatContextProvider>
  )
}
